import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import ListIcon from '@mui/icons-material/List';
import { surfaceBorderSx } from 'components/common/surfaces';

const EmptyPlaceholder = ({ text = 'No data found' }: { text?: React.ReactNode }) => {
  const theme = useTheme();

  return (
    <Box
      data-testid="@empty-placeholder"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        ...surfaceBorderSx,
        p: 4,
        width: '100%',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
        <ListIcon sx={{ color: theme.palette.text.secondary, mt: '2px' }} />
        <Typography component="div" sx={{ color: theme.palette.text.secondary }}>
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmptyPlaceholder;
